import { CameraIntegration } from './base';
import dayjs from 'dayjs';
import { get } from '../../helpers/securityService';
import { ref } from 'vue';

export class Envysion extends CameraIntegration {
  constructor(camera, ...args) {
    super(camera, ...args);
    this.cameraProviderName = 'envysion';
    this.authError = false;
    this.envysionCameraId = null;
    this.isAuthenticated = ref(false);
    this.orgId = args[0];
    this.userId = args[1];

    window.onmessage = async (e) => {
      if (e.data && e.data.camera_ids && e.data.camera_ids.length > 0) {
        this.envysionCameraId = e.data.camera_ids.join(',');
      }
    };

    // waits for auth message from iframe
    window.addEventListener('message', (event) => {
      this.handleLogin(event);
    });
    this.iFrameLogin = this.getLoginIframe();
  }
  async handleLogin(e) {
    if (e?.data?.message === 'Login successful') {
      try {
        const response = await get(
          `security/envysion/auth/${this.camera.location}`,
          {
            orgId: this.orgId,
          },
        );

        if (!response.accessToken) {
          this.authError =
            'We were unable to authenticate your Envysion account. Please try again later.';
        } else {
          this.isAuthenticated.value = !!response.accessToken;
          this.camera.accessToken = response.accessToken;
        }
      } catch (err) {
        console.error(err);
        this.authError =
          'We were unable to authenticate your Envysion account. Please try again later.';
        throw Error(this.authError);
      }
    } else {
      console.error('login failed from Envysion');
    }
  }
  destroy() {
    window.removeEventListener('message', this.handleLogin);
  }

  async checkForCredentials() {
    const { location } = this.camera;

    try {
      const response = await get(`security/check_camera_auth/${location}`, {
        orgId: this.orgId,
      });

      const accessToken = response;
      const auth =
        !!accessToken &&
        accessToken !== 'refresh_token_invalid' &&
        accessToken !== 'Refresh token unavailable.';
      this.isAuthenticated.value = auth;
    } catch (err) {
      console.error(err);
      throw Error(
        'We were unable to authenticate your Envysion account. Please try again later.',
      );
    }
  }

  fetchThumbnails() {
    // ** Envysion has no thumbnails because the iframe handles the different camera options with a dropdown menu
    return [];
  }

  getLoginIframe() {
    const { host, location } = this.camera;
    const loginIframe = `${host}/api/v3/partners/qsrsoft/login?partner_context=${location}-${this.userId}`;
    return loginIframe;
  }

  async fetchVideo(__cameraId, seekTime) {
    const nowPlaying = {
      offsetSeconds: 0,
      seekButtons: true,
      displayTime: this.event.time,
      cameraId: this.envysionCameraId,
    };

    const { location, host } = this.camera;
    const { register } = this.event;

    // If video seek button pressed
    if (seekTime) {
      nowPlaying.offsetSeconds += seekTime;
      nowPlaying.displayTime = dayjs(
        nowPlaying.displayTime,
        'YYYY-MM-DD HH:mm:ss',
      )
        .add(seekTime, 'second')
        .format('YYYY-MM-DD HH:mm:ss');
      this.event.time = nowPlaying.displayTime;
    }

    const isoFormattedDate = dayjs(nowPlaying.displayTime).format();
    const videoDurationSeconds =
      this.camera.commonSettings?.videoDurationSeconds;

    const videoEndTime = dayjs(nowPlaying.displayTime)
      .add(30, 'second')
      .format('HH:mm:ss');

    nowPlaying.description = `${nowPlaying.displayTime} through ${videoEndTime}`;

    const params = {
      start_date_time: isoFormattedDate,
      duration: videoDurationSeconds,
      store_code: location,
      register_number: typeof register === 'number'
        ? String(register)
        : register?.replace(/POS0*/g, '') || '',
      jwt_token: this.camera.accessToken,
    };
    if (nowPlaying.cameraId) params.camera_ids = nowPlaying.cameraId;

    nowPlaying.video = {
      src: `${host}/api/v3/video/embed?${new URLSearchParams(
        params,
      ).toString()}`,
      type: 'iframe',
    };

    return nowPlaying;
  }
}
